import { useMutation } from '@apollo/client';
import { notEmpty } from '@crehana/utils';
import { useRouter } from 'next/router';

import TEAM_UPLOAD_GENERATE_FILE_URL_MUTATION from './graphql/GenerateAttachmentUrl.v4.b2b.graphql';
import type {
  GenerateAttachmentUrl,
  GenerateAttachmentUrlVariables,
} from './graphql/types/GenerateAttachmentUrl';

const useGeneratedAttachmentUrl = () => {
  const { query } = useRouter();
  const { slug } = query as { slug: string };

  const [generateAttachmentUrl, { loading, error }] = useMutation<
    GenerateAttachmentUrl,
    GenerateAttachmentUrlVariables
  >(TEAM_UPLOAD_GENERATE_FILE_URL_MUTATION, {
    context: { clientName: 'v4.b2b' },
  });

  const handleFileUpload = async (file: File) => {
    const response = await generateAttachmentUrl({
      variables: {
        filename: file.name,
        slug,
      },
    });
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (
      !response.data?.generateAttachmentUrl?.success ||
      !response.data.generateAttachmentUrl.uploadAttachment
    )
      return null;

    const { fields, url, filename } =
      response.data.generateAttachmentUrl.uploadAttachment;

    const payload =
      fields?.filter(notEmpty).map(field => ({
        fieldName: field?.fieldName || '',
        fieldValue: field?.fieldValue || '',
      })) || [];

    return {
      payload,
      url,
      file,
      filename,
    };
  };

  return { loading, error, handleFileUpload };
};

export default useGeneratedAttachmentUrl;
